import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppSelector } from '@/store/hooks'

export const ScrollToTop = () => {
  const { pathname } = useLocation()
  const scrollToTopEnabled = useAppSelector((store) => store.scrollToTop.scrollToTopEnabled)

  useEffect(() => {
    if (!scrollToTopEnabled) {
      return
    }

    window.scrollTo(0, 0)
  }, [scrollToTopEnabled, pathname])

  return null
}
